import moment from "moment";
import httpRequest from "../utils/httpRequest";
import httpRequestScoring from "../utils/httpRequestScoring";
import endpoints from "./endpoints";

export const getHighlightArticle = (region) => {
  return httpRequest.get(endpoints.getHighlightArticle, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getGalleryArticle = (slug) => {
  return httpRequest.get(endpoints.getGalleryArticle, {
    params: { region: slug },
  });
};

export const getDetailArticle = (slug, region) => {
  return httpRequest.get(endpoints.getDetailArticle, {
    params: { slug, region: region?.replace(" ", "-") },
  });
};

export const getScheduleMatch = (region, category) => {
  return httpRequest.get(endpoints.getScheduleMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getGroupMatch = (region, category) => {
  return httpRequest.get(endpoints.getGroupMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getKnockoutMatch = (region, category) => {
  return httpRequest.get(endpoints.getKnockoutMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getWhatsNew = (region) => {
  return httpRequest.get(endpoints.getWhatsNew, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getVenue = (region) => {
  return httpRequest.get(endpoints.getVenue, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEvent = (region) => {
  return httpRequest.get(endpoints.getEvent, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEventJourney = () => {
  return httpRequest.get(endpoints.getJourney);
};

export const getEventDetail = (region) => {
  return httpRequest.get(endpoints.getEventDetail, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEventSeries = () => {
  return httpRequest.get(endpoints?.getEventSeries);
};

export const getEventRegionSeries = () => {
  return httpRequest.get(endpoints?.getRegionEventSeries);
};

export const getEventSeriesDetail = (slug) => {
  return httpRequest.get(endpoints?.getEventSeriesDetail(slug.replace(" ", "-")));
};

export const getSection = () => {
  return httpRequest.get(endpoints?.getSection);
};

// API ngirim "Best Player"/"Best Goal Keeper", UI (HallOfFameCard,
// StandingCardNew) nyari "MVP"/"Best Goalkeeper". Disamain di sini sekali,
// termasuk field `category` karena urutan kartu + label + ikon ngambil dari situ.
const HOF_CATEGORY_ALIAS = {
  "Best Player": "MVP",
  "Best Goal Keeper": "Best Goalkeeper",
};

export const normalizeHallOfFame = (res) => {
  const levels = res?.data?.data;
  if (!levels || typeof levels !== "object" || Array.isArray(levels)) return res;
  Object.values(levels).forEach((cats) => {
    if (!cats || typeof cats !== "object" || Array.isArray(cats)) return;
    Object.entries(HOF_CATEGORY_ALIAS).forEach(([from, to]) => {
      // Kalau API udah ngirim nama yang bener, biarin.
      if (!Array.isArray(cats[from]) || cats[to]) return;
      cats[to] = cats[from].map((item) => ({ ...item, category: to }));
      delete cats[from];
    });
  });
  return res;
};

export const getEventHallOfFame = (slug) => {
  return httpRequest
    .get(endpoints?.getHallOfFame(slug))
    .then(normalizeHallOfFame);
};

export const getTimelineSeries = (slug) => {
  return httpRequest.get(endpoints?.getTimeline(slug.replace(" ", "-")));
};

export const postRegistrationForm = (payload) => {
  return httpRequest.post(endpoints?.postRegister, payload);
};

export const postRegistrationDanceForm = (payload) => {
  return httpRequest.post(endpoints?.postRegisterDance, payload);
};

export const postLogin = (data) => {
  return httpRequest.post(endpoints?.login, {
    email: data?.email,
    password: data?.password,
  });
};

export const getRegionGallery = (data) => {
  return httpRequest.get(endpoints?.getRegionGallery, {
    params: {
      year: data?.year,
      main_region: data?.main_region,
    },
  });
};

export const getYearsGallery = (data) => {
  return httpRequest.get(endpoints?.getYearsGallery, {
    params: {
      main_region: data?.main_region,
    },
  });
};

export const getCityCategories = () => {
  // Explicit instead of relying on the API's "defaults to current year"
  // behavior, so the season doesn't silently roll over server-side.
  return httpRequest.get(endpoints?.getCityCategories, {
    params: { year: "2026" },
  });
};

export const getCurrentRegistrationData = () => {
  return httpRequest.get(endpoints?.getCurrentRegistration);
};

export const postUpdateData = (payload) => {
  return httpRequest.post(endpoints?.postUpdateRegister, payload);
};

export const postUpdateDanceData = (payload) => {
  return httpRequest.post(endpoints?.postUpdateDanceRegistration, payload);
};

// Timeout axios ngitung total durasi request termasuk upload body. Payload add
// player bisa ~40MB (18 foto pemain + jersey + PDF, masing-masing maks 2MB), jadi
// default 30 detik dari httpRequest ga cukup buat koneksi HP yang pas-pasan.
export const UPLOAD_TIMEOUT = 3 * 60 * 1000;

export const postAddPlayer = ({ eventRegistrationId, payload }) => {
  return httpRequest.post(endpoints?.postAddPlayer(eventRegistrationId), payload, {
    timeout: UPLOAD_TIMEOUT,
  });
};

export const postAddDancer = ({ eventRegistrationId, payload }) => {
  return httpRequest.post(endpoints?.postAddDanceMember(eventRegistrationId), payload);
};

export const getPaymentDetail = (region_id, school_category) => {
  return httpRequest.get(endpoints?.paymentDetail(), {
    params: { region_id },
  });
};

export const postProofPayment = (payload) => {
  const { registrationId: event_registration_id, formData } = payload;
  return httpRequest.post(endpoints?.postProofPayment(event_registration_id), formData);
};

export const postUpdatePaymentExpired = (payload) => {
  const { registrationId: event_registration_id } = payload;
  return httpRequest.post(endpoints?.postUpdatePaymentExpired(event_registration_id));
};

//LapangBola LiveScore
export const postTokenLiveScore = () => {
  return httpRequest.post(endpoints?.getTokenLiveScore, {
    username: process.env.REACT_APP_LAPANGBOLA_UNAME,
    password: process.env.REACT_APP_LAPANGBOLA_PWD,
  });
};

export const getListOfClub = () => {
  return httpRequest.get(endpoints?.getListOfClub, {
    headers: {
      "User-Agent": "pialabyu.com",
    },
    // hardcode dulu
    data: {
      competition_id: 27476,
      // last_update: new Date("2024-10-07"),
    },
  });
};

export const getCompetititonList = () => {
  return httpRequest.get(endpoints?.getCompetitionList, {
    data: {
      last_update: new Date("2024-10-07"),
    },
  });
};

export const getMatches = (region_id) => {
  return httpRequest.get(endpoints?.getMatchList, {
    params: {
      region_id: region_id?.region_id,
    },
  });
};

export const getMatchesDetail = (id) => {
  return httpRequest.get(endpoints?.getMatchesDetail(id));
};

export const getLiveMatchesDetail = (id) => {
  return httpRequest.get(endpoints?.getLiveMatchesDetail(id));
};

export const getCompetitionsDetail = (competition_id) => {
  return httpRequest.get(endpoints?.getClassmentsDetail(competition_id));
};

// category wajib dikirim: tanpa itu endpoint-nya balikin array kosong walaupun
// datanya ada, dan grouping per Group A/B ikut ilang.
export const getCompetitionsDetailV2 = (region_id, category) => {
  return httpRequest.get(endpoints?.getClassmentsDetailV2, {
    params: {
      region_id,
      category,
    },
  });
};

export const getKnockoutBracket = (region_id) => {
  return httpRequest.get(endpoints?.getKnockoutBracket, {
    params: {
      region_id,
    },
  });
};

// region_id wajib walau di api-docs ditulis opsional: tanpa itu endpoint-nya
// balikin {status: 0, message: "Region ID is required"}.
export const getQualifierBracket = (region_id) => {
  return httpRequest.get(endpoints?.getQualifierBracket, {
    params: {
      region_id,
    },
  });
};

export const getMainRegionGallery = (year) => {
  return httpRequest.get(endpoints?.getMainRegionGallery, {
    params: {
      year,
    },
  });
};

export const getSocAttribute = () => {
  return httpRequest.get(endpoints?.getSocAttribute);
};

export const getTimelineSoc = (slug) => {
  return httpRequest.get(endpoints?.getTimelineSoc(slug));
};

export const getMainRegionSoc = () => {
  return httpRequest.get(endpoints?.getMainRegionSoc, {
    params: {
      has_champion: true,
    },
  });
};

export const getSocChampions = (params) => {
  return httpRequest.get(endpoints?.getSocChampions, {
    params: {
      region: params?.region,
      year: params?.year,
    },
  });
};

export const getMatchTopStats = (params) => {
  return httpRequest.get(endpoints?.getMatchTopStats, {
    params: {
      match_id: params?.matchId,
      player_statistic_id: params?.playerStatisticId,
    },
  });
};

export const getCurrentEventSeries = (category) => {
  return httpRequest.get(endpoints?.getCurrentEventSeries, {
    params: { category },
  });
};

export const getEventCategory = () => {
  return httpRequest.get(endpoints?.getEventCategory);
};

export const getMatchList = (region_id) => {
  return httpRequest.get(endpoints?.getMatchList, {
    params: {
      region_id,
    },
  });
};

export const getMatchDetail = (match_schedule_id) => {
  return httpRequest.get(endpoints?.getMatchDetail, {
    params: {
      match_schedule_id,
    },
  });
};

export const getVideos = (region) => {
  return httpRequest.get(endpoints?.getVideos, {
    params: {
      region,
    },
  });
};

export const getActivity = (region) => {
  return httpRequest.get(endpoints?.getActivity, {
    params: {
      region,
    },
  });
};

export const getActivityDetail = (payload) => {
  const { slug, region } = payload;
  return httpRequest.get(endpoints?.getActivityDetail, {
    params: { slug, region: region?.replace(" ", "-") },
  });
};

export const getDrawingSoc = () => {
  return httpRequest.get(endpoints.getDrawingSoc);
};

export const getGoldenTicketSchools = (category) => {
  return httpRequest.get(endpoints?.getGoldenTicketSchools, {
    params: {
      category,
    },
  });
};
